// extracted by mini-css-extract-plugin
export default {"button":"send_button__FqBH0"};